/**
 * Lake Charles Community App - Feature Data
 * Migrated from legacy lake-charles-landing/data/features.ts
 */

import type { Feature } from '@core';

export const lakeCharlesFeatures: Feature[] = [
  {
    id: 'community-voice',
    icon: '🗳️',
    title: 'Community Voice & Polling',
    headline: 'Make Your Opinion Count',
    description:
      "Create verifiable polls on topics that matter like the sports complex, budget priorities, or infrastructure needs. When 60,000 residents vote on an issue, decision-makers can't ignore it. Our tools help you measure and prove where the community really stands.",
  },
  {
    id: 'petition-organization',
    icon: '✍️',
    title: 'Petition & Initiative Organization',
    headline: 'Organize and Be Heard',
    description:
      "Tired of petitions that go nowhere? Our platform helps you start, circulate, and track community-led petitions with verified support from your neighbors. Whether it's pausing a controversial project or pushing for a new initiative, you'll have the tools to present a unified front to city leaders.",
  },
  {
    id: 'collective-economic-power',
    icon: '💰',
    title: 'Collective Economic Power',
    headline: "Unlock Your Community's Wallet",
    description:
      "What if 500 Lake Charles residents decided to get their oil changed at the same shop this year? That's leverage. Our group purchasing tools let you organize around everyday services, from home repairs to routine maintenance, and negotiate better prices by pooling your buying power. It's not just about saving money. It's about proving that when you organize, vendors listen. And if the community wants to fund a project together without waiting for the city, you can do that too.",
  },
  {
    id: 'secure-discussion',
    icon: '💬',
    title: 'Secure Community Discussion',
    headline: 'A Space to Plan and Strategize',
    description:
      "Public Facebook threads get messy. Our platform gives you a private, resident-only space to discuss what's important. Organize your thoughts, plan your strategy, and collaborate with your neighbors without the noise of public social media.",
  },
];
